module.exports = __webpack_public_path__ + "static/media/company.dbd0a8ba.png";